// module.exports = {
//   IDLE_TIME_THRESHOLD_SEC: 600,        // 10 minutes
//   IDLE_DISTANCE_THRESHOLD_M: 20,       // meters

//   UNREACHABLE_TIMEOUT_MS: 5 * 60 * 1000, // 5 minutes

//   HEARTBEAT_EMIT_INTERVAL_MS: 60 * 1000, // 1 min

//   STATUS: {
//     NOT_CHECKED_IN: "NOT_CHECKED_IN",
//     UNREACHABLE: "UNREACHABLE",
//     IDLE: "IDLE",
//     MOVING: "MOVING",
//     BUSY: "BUSY"
//   }
// };

module.exports = {
  MIN_MOVEMENT_METERS: 10, // Minimum distance to consider as movement
  MOVING_DISTANCE_THRESHOLD_M: 30,    // real movement (>=30m)
  IDLE_TIME_THRESHOLD_SEC: 600,        // 10 minutes
  IDLE_DISTANCE_THRESHOLD_M: 30,       // meters

  UNREACHABLE_TIMEOUT_MS: 3 * 60 * 1000, // 3 minutes

  HEARTBEAT_EMIT_INTERVAL_MS: 60 * 1000, // 1 min

  STATUS: {
    NOT_CHECKED_IN: "NOT_CHECKED_IN",
    UNREACHABLE: "UNREACHABLE",
    IDLE: "IDLE",
    MOVING: "MOVING",
    BUSY: "BUSY"
  },

};

